import { useEffect, useState } from 'react';

import useIsMobile from '../hooks/useIsMobile';

export default function useCheckContentVisibility(prop: any) {
  const [show, setShow] = useState(false);
  const mobile = useIsMobile();

  useEffect(() => {
    if (mobile && (prop?.showOptions?.show === 'Mobile' || prop?.showOptions?.show === 'All')) setShow(true);
    else if (!mobile && (prop?.showOptions?.show === 'Desktop' || prop?.showOptions?.show === 'All')) setShow(true);
  }, [prop, mobile]);

  return show;
}
